<template>
  <a-drawer
    :title="title"
    :visible="visible"
    :width="900"
    :maskClosable="true"
    :destroyOnClose="true"
    placement="right"
    style="overflow: auto; padding-bottom: 53px"
    @close="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item
          label="公告类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            style="width: 120px"
            @change="handleChange"
            v-decorator="[
              'category',
              {
                required: true,
                rules: [{ required: true, message: '请选择公告类型' }]
              }
            ]"
          >
            <a-select-option value="0"> 产品公告 </a-select-option>
            <a-select-option value="1"> 产品资讯 </a-select-option>
            <a-select-option value="2"> 普通公告 </a-select-option>
          </a-select>
          <!-- <j-dict-select-tag
            style="width: 500px;"
            :size="'large'"
            type="list"
            v-decorator="['moduleName']"
            :trigger-change="true"
            dictCode="fund_file"
            placeholder="请选择"
          /> -->
        </a-form-item>
        <a-form-item label="定期类型">
          <a-radio-group
            @change="regularTypeChange"
            v-decorator="[
              'regularType',
              {
                initialValue: 1,
                rules: [{ required: true, message: '请选择公告类型' }]
              }
            ]"
          >
            <a-radio :value="1"> 定期公告 </a-radio>
            <a-radio :value="0"> 其它公告 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="文本类型">
          <a-radio-group
            @change="noticeTypeChange"
            v-decorator="[
              'noticeType',
              {
                initialValue: 1,
                rules: [{ required: true, message: '请选择公告类型' }]
              }
            ]"
          >
            <a-radio :value="1"> 文本 </a-radio>
            <a-radio :value="2"> 文件 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="公告标题">
          <a-input
            size="large"
            :max-length="100"
            style="width: 500px"
            placeholder="请输入公告标题,不超过100个字"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入公告标题,不超过100个字'
                  }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="公告内容" v-if="noticeType == 1">
          <tinymce-editor
            ref="tinymceEditor"
            :teid="'noticeTinymce'"
            style="width: 500px"
            @change="getMyValue"
            v-decorator="['content', { initialValue: '' }]"
          />
        </a-form-item>
        <a-form-item label="公告附件">
          <Upload
            :accept="'.zip, .doc, .docx, .pdf'"
            @handleFileList="handleFileList"
            :fileList="attachments"
            :deleteUrl="'wechatwork-content-biz/content/notice/attachment/del'"
          >
          </Upload>
        </a-form-item>
        <a-form-item
          v-show="noticeType == 2"
          label="文件类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            style="width: 500px"
            :size="'large'"
            type="list"
            v-decorator="['moduleName']"
            :trigger-change="true"
            dictCode="fund_file"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item label="发布渠道栏目">
          <a-tree-select
            size="large"
            style="width: 500px"
            ref="notice"
            :tree-data="columnChannel"
            @change="onChange"
            tree-checkable
            placeholder="请选择发布渠道栏目"
            v-decorator="[
              'channelColumnList',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择发布渠道栏目'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="关联产品">
          <a-select
            size="large"
            style="width: 500px"
            mode="multiple"
            show-search
            placeholder="请选择关联产品"
            :showSearch="true"
            optionFilterProp="label"
            v-decorator="['fundCodes']"
          >
            <a-select-option
              v-for="item in fundList"
              :key="item.fundCode"
              :label="item.fundCodeName"
            >
              {{ item.fundCodeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="发布设置">
          <a-radio-group
            v-decorator="[
              'publishType',
              {
                initialValue: 0,
                rules: [{ required: true, message: '请选择发布设置' }]
              }
            ]"
          >
            <a-radio :value="0"> 立即发布 </a-radio>
            <a-radio :value="1"> 定时发布 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="发布时间">
          <a-date-picker
            size="large"
            style="width: 500px"
            :show-time="{ format: 'HH:mm:ss' }"
            :disabled-date="disabledDate"
            v-decorator="[
              'publishTime',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择发布时间'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="失效时间">
          <a-date-picker
            size="large"
            style="width: 500px"
            :disabled="!this.form.getFieldValue('publishTime')"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            :disabled-date="disabledDateFailureTime"
            v-decorator="['failTime']"
          />
          <span style="margin-left: 10px; color: #999"
            >*不填则代表永久有效</span
          >
        </a-form-item>
        <a-form-item label="可见权限">
          <a-radio-group v-decorator="['permissionType', { initialValue: 0 }]">
            <a-radio :value="0"> 全部人可见 </a-radio>
            <a-radio :value="1"> 开户人可见 </a-radio>
            <a-radio :value="2"> 持有人可见 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number :min="1" v-decorator="['sort']"></a-input-number>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { noticeAdd, noticeEdit, queryReviewedAll } from '@/api/api';

import moment from 'moment';
import tinymceEditor from '@/components/tools/tinymceEditor';
import Upload from '@/components/common/Upload';
import { findTreeNodeArray } from '@/utils/common';
import { postTag } from '../../../../api/manage';

export default {
  name: 'noticeManageModal',
  components: {
    JDictSelectTag,
    tinymceEditor,
    Upload
  },
  props: ['columnChannel'],
  data() {
    return {
      fundList: [],
      fileType: 'file',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      showDialog: false,
      form: this.$form.createForm(this),
      title: '修改',
      width: 800,
      visible: false,
      model: {},
      confirmLoading: false,
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/contNotice/listResult',
        edit: process.env.VUE_APP_CMS_CONTENT + '/content/notice/save',
        detail: process.env.VUE_APP_CMS_CONTENT + '/content/notice/info'
      },
      showPp: false,
      originalId: '',
      ppList: [],
      attachments: [], //附件集合
      cacheData: [],
      editingKey: '',
      columnList: [],
      isShow: false,
      noticeType: 1,
      regularType: 1,
      selectFund: [],
      id: '',
      status: '',
      isReview: ''
    };
  },
  mounted() {
    this.getFundList();
  },
  methods: {
    //选择公告类型
    handleChange(value) {
      console.log(value);
      this.form.setFieldsValue({
        category: value
      });
    },
    noticeTypeChange(e) {
      this.noticeType = e.target.value;
    },
    regularTypeChange(e) {
      this.form.setFieldsValue({
        regularType: e.target.value
      });
    },
    getFundList() {
      queryReviewedAll().then(res => {
        if (res.success) {
          res.result.map(item => {
            item.fundCodeName = item.fundName + '/' + item.fundCode;
          });
          this.fundList = res.result;
          console.log(res, '关联产品');
        }
      });
    },
    getMyValue(val) {
      this.form.setFieldsValue({
        content: val
      });
    },
    //发布渠道栏目
    onChange(value, label, val) {
      this.columnList = value;
      // this.columnList = [];
      // value.forEach((item, index) => {
      //   let obj = {};
      //   obj.columnName = label[index];
      //   obj.columnCode = val.allCheckedNodes[0].node.data.props.code;
      //   obj.channelCode = val.allCheckedNodes[0].node.data.props.channelCode;
      //   obj.columnId = item;
      //   this.columnList.push(obj);
      // });
    },

    moment,
    disabledDate(current) {
      if (this.form.getFieldValue('publishType') == 0) {
        return;
      }
      return current <= moment().endOf('second');
    },
    disabledDateFailureTime(current) {
      if (this.form.getFieldValue('publishTime')) {
        return (
          current <= moment(this.form.getFieldValue('publishTime')).endOf('day')
        );
      }
      return current <= moment().endOf('second');
    },
    add() {
      this.edit({
        noticeType: 1,
        publishSettings: 2,
        category: 0 + ''
      });
    },
    edit(records) {
      this.id = records.id;
      let params = {
        id: records.id
      };
      this.visible = true;
      console.warn(records);
      this.$nextTick(() => {
        this.form.setFieldsValue({
          category: records.category
        });
      });
      postTag(this.url.detail, params).then(res => {
        if (res.success) {
          let arr = [];
          let fundArr = [];
          this.attachments = res.result.attachments;
          if (
            res.result.channelColumnList &&
            res.result.channelColumnList.length > 0
          ) {
            res.result.channelColumnList.forEach(item => {
              // fundCodeName = item.fundName + '/' + item.fundCode;
              console.warn(item.columnId);
              arr.push(item.columnId);
            });
          }
          if (res.result.fundList && res.result.fundList.length > 0) {
            res.result.fundList.forEach(item => {
              fundArr.push(item.fundCode);
            });
          }
          this.noticeType = res.result.noticeType;
          this.columnList = arr;
          this.form.setFieldsValue({
            regularType: res.result.regularType,
            category: res.result.category + '',
            title: res.result.title,
            failTime: res.result.failTime,
            content: res.result.content,
            publishType: res.result.publishType,
            publishTime: res.result.publishTime,
            channelColumnList: arr,
            fundCodes: fundArr,
            permissionType: res.result.permissionType,
            sort: res.result.sort + ''
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        this.$nextTick(() => {
          console.warn(values.fundCodes);
        });
        let timeObj = {
          publishTime: values.publishTime
            ? moment(values.publishTime).format('YYYY-MM-DD HH:mm:ss')
            : '',
          failTime: values.failTime
            ? moment(values.failTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
        };
        this.model = {};
        let formData = Object.assign(this.model, values, timeObj);

        formData.channelColumnList = this.handleChannelData();
        formData.attachments = this.attachments;
        // formData.fundList = this.selectFund;
        formData.publishType = values.publishType;
        if (!err) {
          if (!this.id) {
            values.urls = '';
            formData.status = 0;
            noticeAdd(formData)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.confirmLoading = false;
                  that.$emit('ok');
                } else {
                  that.$message.error(res.message);
                }
              })
              .finally(() => {
                that.confirmLoading = false;
                that.close();
              });
          } else {
            formData.id = this.id;
            formData.isReview = this.isReview;
            formData.status = this.status;
            noticeEdit(formData)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.confirmLoading = false;
                  that.$emit('ok');
                }
              })
              .finally(() => {
                that.confirmLoading = false;
                that.close();
              });
          }
        }
      });
    },
    handleCancel() {
      this.close();
    },
    handleFileList(fileList) {
      let list = fileList;
      this.attachments = [];
      if (fileList && fileList.length > 0) {
        list.forEach(item => {
          let obj = {
            attachmentName: item.name,
            attachmentPath: item.fileName
          };
          this.attachments.push(obj);
        });
      } else {
        this.attachments = [];
      }
    },
    handleReleFund(value) {
      let fundCodes = value;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          fundCodes
        });
      });
    },
    handleSearch(value) {
      let arr = [];
      this.fundList.forEach(item => {
        if (
          item.fundCode.indexOf(value) > -1 ||
          item.fundName.indexOf(value) > -1
        ) {
          arr.push(item);
        }
      });
      this.fundList = arr;
    },
    handleChannelData() {
      let arr = findTreeNodeArray('children', this.columnChannel, e => {
        return this.columnList.filter(item => item == e.id).length > 0;
      });
      console.log('arr++++++', arr);
      let list = [];
      arr.forEach(item => {
        let obj = {};
        obj.columnName = item.name;
        (obj.columnCode = item.code), (obj.channelCode = item.channelCode);
        obj.columnId = item.value;
        list.push(obj);
      });
      return list;
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.select-all {
  position: absolute;
  right: -10px;
  top: -60px;

  button {
    padding-left: 0;
  }
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
